import { bl_pos_card_terminal_RowClass } from '../../../dbschema/bl_pos_card_terminal.model';
import {BaseContainerModel} from '../../base-container.model';


export class PosCardTerminalContainerModel extends BaseContainerModel {
  bl_pos_card_terminal: bl_pos_card_terminal_RowClass = new bl_pos_card_terminal_RowClass();
}
